//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.Feature.js";
import "../no/ScalarMatrixValue.js";
let d=[[],[[["size","objects"],"GetToolMarkers",{},0,0],[["component"],"GetComponentTransformation",{R_:{matrix:"ScalarMatrixValue"}},1,0],[["input","size","flat_geom"],"MapInputGeomToFlattenedGeom",{},1,0],[["flat_geom"],"MapFlattenedGeomToInputGeom",{R_:{parent:"TaggedObject"}},1,0],[["entity"],"GetEntityOnFlat",{R_:{flat_entity:"TaggedObject"}},1,0],[["flat_entity"],"GetEntityOnFormedBody",{R_:{formed_entity:"TaggedObject"}},1,0],[["face"],"GetFaceTransformation",{R_:{matrix:"ScalarMatrixValue"}},1,0]],[]];
SPLM.Features.FlatSolid = class extends SPLM.Features.Feature{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.FlatSolid";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.FlatSolid.ObjectDataCsys = class{
    constructor(flat_solid_object,formed_body_object){
        this.flat_solid_object=flat_solid_object;this.formed_body_object=formed_body_object;}
    get FlatSolidObject(){return this.flat_solid_object}
    set FlatSolidObject(val){this.flat_solid_object = val}
    get FormedBodyObject(){return this.formed_body_object}
    set FormedBodyObject(val){this.formed_body_object = val}
};

export default SPLM;